import React from 'react';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Button from '@amzn/meridian/button';
import CustomAlert from '../../commonComponents/CustomAlert';

export default class FlowPlannerErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('FlowPlanner render error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <Column spacingInset="400" alignmentVertical="top" width="100%">
          <CustomAlert backgroundColor="#fcf2be" title="Flow Planner encountered an error and could not render.">
            <Text>{this.state.error.message}</Text>
          </CustomAlert>
          <Button type="tertiary" onClick={() => this.setState({ error: null })}>
            Try Again
          </Button>
        </Column>
      );
    }
    return this.props.children;
  }
}
